import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationLanguages } from 'src/app/enums/lang';
import { Category } from 'src/app/interfaces/category';
import { CategoriesService } from 'src/app/pages/home/service/categories.service';

@Component({
  selector: 'app-home-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss'],
})
export class CategoriesComponent implements OnInit {
  ApplicationLanguages = ApplicationLanguages;
  @Input() currentLang: string =
    localStorage.getItem('lang') || ApplicationLanguages.Ar;

  categories: Category[] = [];
  customOptionsSliderOne: any = {
    loop: true,
    margin: 20,
    nav: false,
    autoplay: true,
    autoplayTimeout: 3000,
    rtl: true,
    smartSpeed: 600,
    dots: false,
    autoplayHoverPause: false,
    slideTransition: 'ease-in-out',
    responsive: {
      0: {
        items: 1,
      },
    },
  };

  constructor(
    private categoriesService: CategoriesService,
    protected translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.getCategoriesData();
  }

  getCategoriesData() {
    this.categoriesService.getCategories().subscribe({
      next: (response: any) => {
        this.categories = response;
      },
      error: (error: any) => {
        console.error('Error fetching data:', error);
      },
    });
  }
}
